import { render } from "./ComboardDetail.vue?vue&type=template&id=768ff497&scoped=true"
import script from "./ComboardDetail.vue?vue&type=script&lang=js"
export * from "./ComboardDetail.vue?vue&type=script&lang=js"

import "./ComboardDetail.vue?vue&type=style&index=0&id=768ff497&scoped=true&lang=css"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768ff497"]])

export default __exports__